import { get, handleApiError, post } from '@helpers/httpClient';

export async function login({
  username,
  password,
  remember = true,
}: {
  username: string;
  password: string;
  remember?: boolean;
}) {
  const result = await post('/ajax/login_start.php', {
    login: username,
    pass: password,
    is_remember: remember,
  }).then<{ userId: string; hash: string }>(handleApiError);
  return result;
}

export async function logout(cb: () => void) {
  await post('/ajax/login_out.php', {});
  cb();
}

export interface IBaseUserDTO {
  id: string;
  name: string;
  surname: string;
  photo_50: string;
}
export interface ICurrentUserDTO extends IBaseUserDTO {
  session_start: string;
}

interface ILoginCheckResult {
  result: boolean;
  hash: string;
  user?: ICurrentUserDTO;
}

export async function loginCheck() {
  return get('/ajax/login_check.php').then<ILoginCheckResult>(handleApiError);
}
